module.exports = __webpack_public_path__ + "img/AvoidedCost.ef767e0d.svg";